import { AxiosPromise } from 'axios';
import { IThemeFormValues } from '../form';
import { instance } from '../../../../services';

const createTheme = (data: IThemeFormValues): AxiosPromise =>
  instance.post('/api/themes', data);

export default createTheme;
